import { Space, SpaceProps } from 'antd';
import clsx from 'classnames';
import React, {
  FC,
  PropsWithChildren,
} from 'react';
import './index.scss';

export const TdsSpace: FC<PropsWithChildren<SpaceProps>>  = (props) => {
  const { children, className, ...rest } = props;
  return <Space
    className={clsx('tds-space', className)}
    {...rest}
    >
  {children}
  </Space>;
};

